const ug = {
	'注册/登录': 'تىزىملاش/ كىرىش',
	'点击右上角的按钮,选择在浏览器中打开': 'ئۈستى بۇرجەكتىكى كۇنۇپكىنى بېسىڭ,تور كۆرگۈچتە ئېچىڭ',
	'学习最地道的中文': 'دۆلەت تىلىنى ئۆلچەملىك ئۆگىنىش',
	'VIP套餐': 'VIP يۈرۈشلۈكى',
	'{N}个月': '{num} ئاي',
	'节省{%}': 'تېجەش {percent}',
	'立即购买': 'سېتىۋېلىش',
	'点击购买/续费即表示您已阅读并同意《自动续费服务规则》、《服务使用协议》、《用户隐私协议》': 'سېتىۋېلىش\داۋاملىق سېتىۋېلىشنى چەكسىڭىز، <span onclick="protocol()"> «ئىشلىتىش مۇلازىمىتى كېلىشىمى» </span>، <span onclick="privacy()">«ئىشلەتكۈچىلەر مەخپىيەتلىك كېلىشىمى»</span> قاتارلىقلارنى ئوقۇپ، قوشۇلغان بولىسىز',
		'畅学600+超级进阶课程': '600 دىن ئارتۇق دەرس بار',
		'超20年资深教研团队倾心编写': '20 يىللىق تەجرىبىگە ئىگە ئوقۇتۇش قوشۇنى ئەستايىدىل تۈزگەن','词汇': 'سۆزلۈك',
	'选取高频词汇，学以致用': 'كۆپ ئىشلىتىلىدىغان سۆزلەر تاللانغان، ئۆگەنگەننى ئىشەتكىلى بولىدۇ',
	'全方位训练听、说、读、写': 'ئاڭلاش، سۆزلەش، ئوقۇش، يېزىش مەشىقىنىڭ ھەممىسى بار',
	'语法': 'گىرامماتىكا',
	'科学系统的语法知识体系': 'ئىلىمىي، سىستېمىلىق گىرامماتىكا بىلىملىرى بار',
	'掌握语法结构，灵活运用': 'جۈملە قۇرۇلمىسىنى ئىگىلەپ، جانلىق ئىشلەتكىلى بولىدۇ',
	'课文': 'تېكىست',
	'100+ 日常话题，沉浸式中文学习体验': '100دىن ئارتۇق مەزمۇن ئارقىلىق دۆلەت تىلىنى چوڭقۇر چۆكۈپ ئۆگەنگىلى بولىدۇ',
	'AI引擎智能打分，从此大胆开口说中文': 'ماشىنا نومۇر قويىدۇ، تارتىنماي سۆزلەپ، دۆلەت تىلى ئۆگەنگىلى بولىدۇ',
	'小测试': 'كىچىك سىناق',
	'检验课程内容的学习情况': 'ئۆگىنىش ئەھۋالىنى تەكشۈرگىلى بولىدۇ',
	'定位薄弱项，给出学习推荐': 'ئاجىز نۇقتىلارنى كۆرسىتىپ، ئۆگىنىشىڭىزگە تەكلىپ بېرىدۇ',
	'智能AI引擎为你保驾护航': 'ئەقلىي ئىقتىدارلار سىزگە ھەمراھ',
	'个性化学习推荐，由浅入深系统学习': 'خاسلاشقان ئۇسۇلدا ئاددىيدىن باشلاپ ئۆگەنگىلى بولىدۇ',
	'独家AI算法分析，科学安排复习': 'AI تەھلىلى ئارقىلىق، ئىلمىي مەشىق قىلدۇرىدۇ',
	'智能错题收集，帮你查漏补缺': 'خاتالىقلارنى توپلاپ، ئاجىزلىقىڭىزنى كۆرسىتىپ بېرىدۇ',
	'VIP专属特权': 'VIP ئىمتىيازى',
	'功能特权': 'ئىقتىدار',
	'VIP': 'VIP',
	'普通用户': 'ئادەتتىكى ئىشلەتكۈچى',
	'知识库': 'بىلىم ئامبىرى',
	'Flashcard': 'Flashcard',
	'收藏': 'يىغىش',
	'用户反馈': 'ئىشلەتكۈچىلەر ئىنكاسى',
	'学习{N}天': '',
	'初始水平': 'دەسلەپكى سەۋىيە',
	'目前水平': 'ھازىرقى سەۋىيە',
	'需要帮助？': 'ياردەم كېرەكمۇ؟',
	'选择支付方式': 'تۆلەش ئۇسۇلىنى تاللاش',
	'微信': 'ئۈندىدار',
	'支付宝': 'جىفۇباۋ',
	'立即支付': 'سېتىۋالىمەن',
	'购买成功': 'سېتىۋېلىندى',
	'体验': 'سىناق',
	'支付失败':'چىقىم قىلىنمىدى',
	'确定支付完成了吗?':'ھەق تۆلەش تاماملاندىمۇ؟',
	'我已支付完成':'پۇل تۆلەپ بولدۇم',
	'重新支付':'قايتا تۆلەش',
    '确定退出登录？': 'ھېساباتتىن چېكىنەمسىز؟',
	'确定': 'جەزملەش',
    '取消': 'بىكار قىلىش',
	'支付失败': 'چىقىم قىلىنمىدى',
	"请输入邮箱":"ئىلخەت كىرگۈزۈڭ",
	"请输入密码":"مەخپىي نومۇر كىرگۈزۈڭ",
	"确认密码":"مەخپىي نومۇر جەزملەش",
	"忘记密码":"مەخپىي نومۇرنى ئۇنۇتتۇم",
	"请输入已有账号":"ھېساباتىڭىزنى كىرگۈزۈڭ",
	"填写验证码":"",
	"获取验证码":"دەلىللەش كودى ئېلىش",
	"提交":"تاپشۇرۇش",
	"登录":"كىرىش",
	"所在国家":"دۆلەت",
	"请输入手机号":"يانفون نومۇرىنى كىرگۈزۈڭ",
	"使用邮箱":"ئېلخەتتە",
	"使用手机":"يانفوندا",
	"注册":"تىزىملىتىش",
	"用户隐私与使用协议":"ئىشلەتكۈچىلەر مەخپىيەتلىك ۋە ئىشلىتىش كېلىشىمى",
	"打开APP学习":"ئەپنى ئېچىپ ئۆگىنىش",
}
export default ug;